import ContentTitle from '../General/contentTitle';
import ArrowButton from '../General/arrowButton';
import various from '../General/various';
import FadeIn from '../Animation/fadeIn';
// import ScrollTriggers from '../Animation/scrollTriggers';

import { makeStyles } from '@material-ui/core';
import { branchNameIndex } from '../Apis/apis';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { branchSectionUrl } from '../Pages/branch';
import { BranchName } from '../General/branchName';

const useStyles = makeStyles((theme) => ({
  box: {},
  clubIndex: {
    textAlign: 'end',
    fontWeight: 'bold',
    letterSpacing: '0.5rem',
    marginBottom: '16px',
    lineHeight: 3,
    fontSize: '1.5rem',
    '@media screen and (max-width:500px)': {
      fontSize: '1.1rem !important',
    },
  },
  clubArea: {
    color: theme.palette.primary.main,
  },
  link: {
    '&:link': {
      color: '#000',
    },
    '&:visited': {
      color: '#000',
    },
    '&:hover': {
      fontWeight: 900,
    },
  },
  arrow: {
    float: 'right',
  },
}));

const BranchOnTopPage = () => {
  const [raw, setRaw] = useState();
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState();
  const [clubs, setClubs] = useState();
  const [specials, setSpecials] = useState();
  // const [clubLength, setClubLength] = useState();

  const classes = useStyles();
  const branchAreaTitle = {
    titleList: ['Branch'],
    sub: '同好会・特別稽古会',
  };
  const fadeProps = {
    direction: '$up',
    duration: '1s',
    fillMode: 'forwards',
    timingFunction: 'ease-out',
  };

  useEffect(() => {
    branchNameIndex(setRaw);
  }, []);

  useEffect(() => {
    if (raw) setBranches(raw);
  }, [raw]);

  const callback = useCallback(() => {
    const items = (division) => branches.filter((branch) =>
      branch.division === division
    ).map((branch) => (
      <div key={branch.uuid}>
        <Link className={classes.link} to={branchSectionUrl(branch)} style={{ display: 'inline-block' }}>
          <BranchName branch={branch} highlightClassName={classes.clubArea} />
        </Link>
      </div>
    ));
    return { club: items('club'), specialClub: items('specialClub') };
  }, [branches, classes]);

  useEffect(() => {
    if (branches) {
      setView(true);
      setLoading(false);
    }
  }, [branches]);

  useEffect(() => {
    if (view) {
      setClubs(callback().club);
      setSpecials(callback().specialClub);
    }
  }, [view, callback]);

  // useEffect(() => {
  //   if (Object.keys(branches).length) {
  //     if (branches.club) {
  //       setClubLength(branches.club.length);
  //     }
  //   }
  // }, [branches]);

  return (
    <div className={classes.box}>
      {loading ? null : view ? (
        <>
          {/* <FadeIn fadeProps={fadeProps}> */}
          <ContentTitle title={branchAreaTitle} />
          {/* </FadeIn> */}
          <div className={classes.clubIndex}>
            {clubs}
            {specials}
          </div>
          <FadeIn fadeProps={fadeProps}>
            <div className={classes.arrow}>
              <Link to={various.general.branch}>
                <ArrowButton buttonName="VIEW ALL" color="#000" />
              </Link>
            </div>
          </FadeIn>
        </>
      ) : null}
    </div>
  );
};
export default BranchOnTopPage;
